export default __webpack_public_path__ + "static/media/sunny.00c07797.svg";